import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VERSION_INFO } from '../../../../environments/version';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <footer class="app-footer">
      <span class="footer-item">ic1-mfrm-web</span>
      <span class="footer-sep">·</span>
      <span class="footer-item">{{ commitHash }}</span>
      <span class="footer-sep">·</span>
      <span class="footer-item">Built: {{ buildDate }}</span>
    </footer>
  `,
  styles: [`
    .app-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 28px;
      background: #1e293b;
      color: #94a3b8;
      font-size: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      z-index: 100;
      border-top: 1px solid #334155;
    }
    .footer-sep { opacity: 0.5; }
  `]
})
export class AppFooterComponent {
  readonly commitHash = VERSION_INFO.commitHashShort;
  readonly buildDate = VERSION_INFO.buildDate;
}
